
export default {
    taxcodeList: [],
    currentTaxcodeObject:{}
};
